define("shared/utils/object-methods/object-map", ["exports", "lodash"], function (_exports, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class objectMap
   * @extends Utils
   */

  /**
   * Map through object entries and apply given callback to
   * the entries returning the modified object
   *
   * @method objectMap
   * @param {Object} obj Object to be mapped
   * @param {Function} callback Callback to be called for every map iteration
   *
   * @return {Object} Mapped object
   */
  const objectMap = (obj, callback) => (0, _lodash.fromPairs)(Object.entries(obj || {}).map(callback));
  var _default = _exports.default = objectMap;
});